/**
 * getInitials — iniciales (hasta 2) del nombre para el fallback de avatar.
 * Centraliza la lógica que estaba duplicada en múltiples páginas/componentes.
 */
export function getInitials(name?: string | null): string {
  if (!name) return '?';
  const ini = name
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return ini || '?';
}
